function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  clipPath: "url(#prefix__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.538 46.592l-4.086 4.086c-1.694 1.694-4.438 1.694-6.13 0-1.693-1.692-1.693-4.436 0-6.129l8.173-8.173c1.693-1.693 4.437-1.693 6.13 0 .563.564 1.478.564 2.042 0 .565-.565.565-1.48 0-2.044-2.82-2.821-7.394-2.821-10.215 0l-8.174 8.174c-2.821 2.821-2.821 7.395 0 10.216 2.82 2.822 7.395 2.822 10.217 0l4.087-4.087c.564-.564.564-1.479 0-2.043-.565-.564-1.48-.564-2.044 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.722 22.277c-2.82-2.821-7.396-2.821-10.217 0l-4.902 4.903c-.565.564-.565 1.479 0 2.043.564.564 1.479.564 2.043 0l4.902-4.902c1.693-1.693 4.438-1.693 6.131 0 1.693 1.692 1.693 4.436 0 6.129l-8.99 8.99c-1.693 1.693-4.437 1.693-6.13 0-.563-.564-1.478-.564-2.042 0-.565.564-.565 1.479 0 2.043 2.82 2.821 7.394 2.821 10.215 0l8.99-8.99c2.822-2.821 2.822-7.395 0-10.216z"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 37.5,
  r: 36,
  stroke: "#000",
  strokeOpacity: 0.8,
  strokeWidth: 3
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.162 20.161H54.839V54.838H20.162z"
})));

function SvgCopyLinkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    fill: "none",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkLogo);
export default __webpack_public_path__ + "static/media/copy-link-logo.c70f30ed.svg";
export { ForwardRef as ReactComponent };